import { render } from "./BillingInformation.vue?vue&type=template&id=483496ca&scoped=true"
import script from "./BillingInformation.vue?vue&type=script&lang=js"
export * from "./BillingInformation.vue?vue&type=script&lang=js"

import "./BillingInformation.vue?vue&type=style&index=0&id=483496ca&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-483496ca"]])

export default __exports__